import { render, staticRenderFns } from "./effectues.vue?vue&type=template&id=116d2172"
import script from "./effectues.vue?vue&type=script&lang=js"
export * from "./effectues.vue?vue&type=script&lang=js"
import style0 from "./effectues.vue?vue&type=style&index=0&id=116d2172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports